import Cache from '../lib/cache'

const CURRENT_USER_CACHE_KEY = 'u'
const CACHE = new Cache(CURRENT_USER_CACHE_KEY)

/**
 * Temporary way of having current user access across all components
 */
export default {
  install(Vue) {
    const $currentUser = {
      get id() {
        const c = CACHE.get()
        return c.id || false
      },
      get entity() {
        const c = CACHE.get()
        return Object.assign({}, c)
      },
      get isAdmin() {
        const c = CACHE.get()
        return c.id === 1 // TODO: placeholder
      },
    }
    Vue.prototype.$currentUser = $currentUser
  },
}
